export const CLOUD_PROXY = "account-center/cloud-proxy.html";
export const MFA_PROXY = "account-center/mfaproxy.html";